export const dp_r2 = 'var(--dp_r2)';
export const dp_r4 = 'var(--dp_r4)';
export const dp_r8 = 'var(--dp_r8)';
export const dp_r12 = 'var(--dp_r12)';
export const dp_r16 = 'var(--dp_r16)';
